import { IsNumber, IsOptional, IsString, ValidateNested, IsArray } from 'class-validator';
import { Type } from 'class-transformer';
class MoneyGraph {
    @IsString()
    dealCode!: string;
    @IsNumber()
    invid!: number;
    @IsString()
    invoiceDate!: string;
    @IsNumber()
    projectId!: number;
    @IsNumber()
    royaltyAmount!: number;
}

export class MoneyListItemDto {
    @IsNumber()
    projectId!: number;
    @IsString()
    assetCode!: string;
    @IsString()
    contactDisplayContract!: string;
    @IsString()
    contactNameContract!: string;
    @IsString()
    contractTitle!: string;
    @IsOptional()
    @IsString()
    sourceType!: string;
    @IsString()
    royaltyPeriod!: string;
    @IsOptional()
    @IsString()
    invDescription!: string | null;
    @IsNumber()
    invAmount!: number;
    @IsString()
    invDate!: string;
    @IsNumber()
    nextInvDate!: number;
    @IsOptional()
    @IsString()
    invStatus!: string;
    @IsString()
    accountingTerm!: string;
    @IsOptional()
    @IsString()
    dealType!: string | null;
    @IsOptional()
    @IsString()
    incomeType!: string | null;
    @IsNumber()
    totalRows!: number;
    @IsArray()
    @ValidateNested()
    @Type(() => MoneyGraph)
    graphs!: MoneyGraph[];
    @IsString()
    contactImage!: string | null;
}
